export default "__VITE_ASSET__Dct5gqE4__"